module.exports = __webpack_public_path__ + "static/img/wl1550.4f4dbc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wl1550.jpg
// module id = tpbs
// module chunks = 0